"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_SYSTEM_ERROR_MESSAGE = exports.LOGIN_NETWORK_ERROR_MESSAGE = exports.LOGIN_ERROR_CODE = exports.LOGIN_CREDENTIAL_ERROR_MESSAGE = exports.CAPTCHA_INVALID_MESSAGE = exports.CAPTCHA_EXPIRED_MESSAGE = void 0;
exports.getLoginDisplayMessage = getLoginDisplayMessage;
exports.isAccountLocked = isAccountLocked;
exports.isCaptchaExpired = isCaptchaExpired;
exports.isCaptchaInvalid = isCaptchaInvalid;
exports.isLoginRateLimit = isLoginRateLimit;
exports.isNetworkError = isNetworkError;
exports.isSecurityThreat = isSecurityThreat;
exports.isSliderVerifyRequired = isSliderVerifyRequired;
exports.normalizeLoginError = normalizeLoginError;
exports.shouldBlurLoginCredentialMessage = shouldBlurLoginCredentialMessage;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/** 登录/验证码安全错误码，与后端 LoginSecurityCodeEnum 保持一致 */
var LOGIN_ERROR_CODE = exports.LOGIN_ERROR_CODE = {
  SECURITY_THREAT: 40001,
  SLIDER_VERIFY_REQUIRED: 40002,
  LOGIN_RATE_LIMIT: 40003,
  CAPTCHA_INVALID: 40004,
  ACCOUNT_LOCKED: 40005,
  CAPTCHA_EXPIRED: 40006
};
var LOGIN_CREDENTIAL_ERROR_MESSAGE = exports.LOGIN_CREDENTIAL_ERROR_MESSAGE = '账号或密码错误!';
var CAPTCHA_INVALID_MESSAGE = exports.CAPTCHA_INVALID_MESSAGE = '验证码错误';
var CAPTCHA_EXPIRED_MESSAGE = exports.CAPTCHA_EXPIRED_MESSAGE = '验证码已过期';
var LOGIN_SYSTEM_ERROR_MESSAGE = exports.LOGIN_SYSTEM_ERROR_MESSAGE = '系统繁忙，请稍后再试';
var LOGIN_NETWORK_ERROR_MESSAGE = exports.LOGIN_NETWORK_ERROR_MESSAGE = '网络异常，请稍后重试';
function normalizeLoginError(err) {
  if (err && _typeof(err) === 'object' && err.code != null && !isAxiosNetworkLike(err)) {
    return {
      code: err.code,
      message: err.message || ''
    };
  }
  return {
    code: null,
    message: typeof err === 'string' ? err : err && err.message || ''
  };
}

/** axios 断网/超时/服务不可用（无业务 code） */
function isNetworkError(err) {
  if (!err || _typeof(err) !== 'object') {
    return false;
  }
  if (isAxiosNetworkLike(err)) {
    return true;
  }
  var msg = String(err.message || '').toLowerCase();
  return msg === 'network error' || msg.includes('timeout') || msg.includes('econnrefused') || msg.includes('failed to fetch');
}
function isAxiosNetworkLike(err) {
  // axios: response 缺失 + request 存在 = 发出了请求但无响应（断网/服务挂了）
  if (err.isAxiosError || err.config) {
    if (!err.response && err.request) {
      return true;
    }
    if (err.code === 'ECONNABORTED' || err.code === 'ERR_NETWORK') {
      return true;
    }
  }
  return false;
}
function isSecurityThreat(err) {
  var _normalizeLoginError = normalizeLoginError(err),
    code = _normalizeLoginError.code;
  return code === LOGIN_ERROR_CODE.SECURITY_THREAT;
}
function isSliderVerifyRequired(err) {
  var _normalizeLoginError2 = normalizeLoginError(err),
    code = _normalizeLoginError2.code;
  return code === LOGIN_ERROR_CODE.SLIDER_VERIFY_REQUIRED;
}
function isLoginRateLimit(err) {
  var _normalizeLoginError3 = normalizeLoginError(err),
    code = _normalizeLoginError3.code;
  return code === LOGIN_ERROR_CODE.LOGIN_RATE_LIMIT;
}
function isCaptchaInvalid(err) {
  var _normalizeLoginError4 = normalizeLoginError(err),
    code = _normalizeLoginError4.code;
  return code === LOGIN_ERROR_CODE.CAPTCHA_INVALID;
}
function isCaptchaExpired(err) {
  var _normalizeLoginError5 = normalizeLoginError(err),
    code = _normalizeLoginError5.code;
  return code === LOGIN_ERROR_CODE.CAPTCHA_EXPIRED;
}
function isAccountLocked(err) {
  var _normalizeLoginError6 = normalizeLoginError(err),
    code = _normalizeLoginError6.code;
  return code === LOGIN_ERROR_CODE.ACCOUNT_LOCKED;
}
function shouldBlurLoginCredentialMessage(err) {
  if (isNetworkError(err)) {
    return false;
  }
  if (isSecurityThreat(err) || isSliderVerifyRequired(err) || isLoginRateLimit(err) || isCaptchaInvalid(err) || isCaptchaExpired(err)) {
    return false;
  }
  // 仅账号锁定等凭证类错误模糊提示，系统错误(500)等必须展示真实信息
  return isAccountLocked(err);
}
function getLoginDisplayMessage(err) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LOGIN_CREDENTIAL_ERROR_MESSAGE;
  if (isNetworkError(err)) {
    return LOGIN_NETWORK_ERROR_MESSAGE;
  }
  if (isCaptchaInvalid(err)) {
    var _normalizeLoginError7 = normalizeLoginError(err),
      _message = _normalizeLoginError7.message;
    return _message || CAPTCHA_INVALID_MESSAGE;
  }
  if (isCaptchaExpired(err)) {
    var _normalizeLoginError8 = normalizeLoginError(err),
      _message2 = _normalizeLoginError8.message;
    return _message2 || CAPTCHA_EXPIRED_MESSAGE;
  }
  var _normalizeLoginError9 = normalizeLoginError(err),
    code = _normalizeLoginError9.code,
    message = _normalizeLoginError9.message;
  if (code === 500) {
    return message || LOGIN_SYSTEM_ERROR_MESSAGE;
  }
  if (shouldBlurLoginCredentialMessage(err)) {
    return LOGIN_CREDENTIAL_ERROR_MESSAGE;
  }
  // 无业务码时不要一律当成账号密码错误（例如 Network Error）
  if (code == null) {
    if (!message) {
      return LOGIN_NETWORK_ERROR_MESSAGE;
    }
    var lower = message.toLowerCase();
    if (lower === 'network error' || lower.includes('timeout')) {
      return LOGIN_NETWORK_ERROR_MESSAGE;
    }
    return message;
  }
  return message || fallback;
}